$(document).on('turbolinks:load', function() {
  var $overlay = $('#delete-confirm-overlay');
  var $input = $overlay.length ? $('#delete-confirm-input') : null;
  var $submitBtn = $overlay.length ? $overlay.find('.delete-confirm-submit') : null;
  var $nameSpan = $overlay.length ? $overlay.find('.js-delete-confirm-name') : null;
  var deleteUrl = '';

  function submitDelete(url) {
    var csrfToken = $('meta[name="csrf-token"]').attr('content');
    var $form = $('<form>', {
      method: 'POST',
      action: url
    });
    $form.append($('<input>', { type: 'hidden', name: '_method', value: 'delete' }));
    $form.append($('<input>', { type: 'hidden', name: 'authenticity_token', value: csrfToken }));
    $('body').append($form);
    $form.submit();
  }

  $('[data-delete-confirm]').off('click.deleteConfirm').on('click.deleteConfirm', function(e) {
    e.preventDefault();
    e.stopPropagation();

    var leagueName = $(this).data('league-name');
    var url = $(this).data('delete-url');
    var matchCount = $(this).data('match-count');

    if (matchCount === 0) {
      if (confirm($(this).data('confirm-message'))) {
        submitDelete(url);
      }
      return;
    }

    if ($overlay.length === 0) return;

    deleteUrl = url;
    $nameSpan.text(leagueName);
    $input.val('');
    $submitBtn.prop('disabled', true);
    $overlay.addClass('active');
    $input.focus();
  });

  if ($overlay.length === 0) return;

  // 入力チェック
  $input.off('input.deleteConfirm').on('input.deleteConfirm', function() {
    $submitBtn.prop('disabled', $(this).val() !== $input.data('confirm-word'));
  });

  // 削除実行
  $submitBtn.off('click.deleteConfirm').on('click.deleteConfirm', function() {
    if ($input.val() !== $input.data('confirm-word')) return;
    submitDelete(deleteUrl);
  });

  // モーダルを閉じる
  function closeModal() {
    $overlay.removeClass('active');
    $input.val('');
    $submitBtn.prop('disabled', true);
  }

  $overlay.off('click.deleteConfirm').on('click.deleteConfirm', function(e) {
    if ($(e.target).is($overlay)) closeModal();
  });

  $overlay.find('.delete-confirm-close').off('click.deleteConfirm').on('click.deleteConfirm', closeModal);
  $overlay.find('.delete-confirm-cancel').off('click.deleteConfirm').on('click.deleteConfirm', closeModal);

  $(document).off('keydown.deleteConfirm').on('keydown.deleteConfirm', function(e) {
    if (e.key === 'Escape' && $overlay.hasClass('active')) closeModal();
  });

  // Turbolinksキャッシュ対策
  $(document).off('turbolinks:before-cache.deleteConfirm').on('turbolinks:before-cache.deleteConfirm', function() {
    $overlay.removeClass('active');
  });
});
